import * as React from 'react';
import TerminalInstallationList from './TerminalInstallationList';
import {Footer} from "components/common/InfinityReactTable";

export default class TerminalInstallation extends React.Component {
    // nie korzystam tu z żadnych propsów ani stateów dlateo wydaje mi się, że wystarczy wyrenderować tylko jeden raz.
    public shouldComponentUpdate(nextProps: any, nextState: any, nextContext: any): boolean {
        return false;
    }

    public render() {
        return (
            <div className="main__content main__content--no-padding">
                <TerminalInstallationList/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TerminalInstallation/TerminalInstallation.tsx